(() => {
  const script = document.querySelector('script[data-cm-relocation-expiry]');
  const expiresAt = Number(script?.dataset.cmRelocationExpiry);
  if (!Number.isFinite(expiresAt) || expiresAt <= 0) return;

  let timer;
  const checkExpiry = () => {
    window.clearTimeout(timer);
    const remaining = expiresAt - Date.now();
    if (remaining <= 0) {
      document.documentElement.classList.add('cm-relocation-expired');
      return;
    }
    timer = window.setTimeout(checkExpiry, Math.min(remaining, 86400000));
  };

  checkExpiry();
  window.addEventListener('pageshow', checkExpiry);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkExpiry();
  });
})();
